const menuList = [
    {
        title: '趣互动',
        subList: [
            {
                title: '趣互动产品概述',
                content: '<div>趣互动通过游戏化的产品设计、智能推荐技术的运用，实现高效的导购管理和导购赋能，帮助企业激活导购力量。</div>'
            },
            // {
            //     title: '趣互动应用配置',
            // },
            // {
            //     title: '趣互动应用介绍-合成签到'
            // },
            // {
            //     title: '趣互动应用介绍-红包雨'
            // },
            // {
            //     title: '趣互动应用介绍-刮刮卡'
            // },
            // {
            //     title: '趣互动应用介绍-心愿盒'
            // }
        ]
    },
    {
        title: '医美会员',
        subList: [
            {
                title: '医美会员产品概述',
                content: '帮助医美机构搭建私域流量池，提供储值、拼团、秒杀等会员活动，实现医美私域数字化增长。'
            }
        ]
    },
    {
        title: '趣导购',
        subList: [
            {
                title: '趣导购产品概述',
                content: '趣导购通过游戏化的产品设计和精准的数学模型，帮助企业快速拉新、增加留存和提高GMV。'
            }
        ]
    },
    {
        title: '云柜台',
        subList: [
            {
                title: '云柜台产品概述',
                content: '云柜台通过游戏化的产品设计、智能推荐技术的运用，实现高效的导购管理和导购赋能，帮助企业激活导购力量。'
            }
        ]
    }
]

export {
    menuList
}